const Logo = ({ isCollapsed = false, className = '' }: { isCollapsed?: boolean, className?: string }) => {
    return (
        <img
            src={isCollapsed ? '/images/Vector.png' : '/images/Logo.png'}
            alt="Logo"
            className={className}
            style={{
                width: !isCollapsed ? '172px' : '50px',
                height: '50px',
                objectFit: 'contain',
                objectPosition: 'left center'
            }}
        />
    )
}

export default Logo;